export default {"src":"/_next/static/media/open_regular.b8809b17.svg","height":24,"width":24};